if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        console.log('SKio subscription widget custom script.........');
        const observer = new MutationObserver(() => {
          // const label = document.querySelector('.skio-plan-picker');
          const label = document.querySelector('.skio-group-content');
          if (label) {
            const buyButton = document.querySelector('.product-form__submit.button');
            const buyButtonTextEl = document.querySelector(".button-text_ATC");
            const buyButtonText = buyButtonTextEl.textContent;
            // const element = document.createElement('span');
            // element.setAttribute('class', 'subscription-heading');
            // element.textContent = 'your plan';
            // label.prepend(element); // Heading of Plan

            const radioContainer = document.createElement('div');
            radioContainer.id = 'radioContainer';
            const select = document.querySelector('.skio-frequency');
            const name = 'skio-frequency-group';
            Array.from(select.options).forEach((option, index) => {
              const wrapper = document.createElement('label');
              wrapper.className = 'skio-custom-radio';

              const radio = document.createElement('input');
              radio.type = 'radio';
              radio.name = name;
              radio.value = option.value;

              if (option.selected) {
                radio.checked = true;
              }

              radio.addEventListener('click', () => {
                const label = radio.closest('label');
                const text = label.querySelector('.skio-custom-radio-label').innerHTML;
                const button = document.querySelector('.subscription-plan-heading');
                button.querySelector('span').innerHTML = text;
                button.querySelector('span').classList.remove('not-selected');

                // const isOpen = radioContainer.classList.contains('open');
                // radioContainer.classList.toggle('open', !isOpen);
                // button.querySelector('.arrow-icon').classList.toggle('open', !isOpen);

                // Update the <select> value
                select.value = radio.value;

                // Trigger change event
                const event = new Event('change', { bubbles: true });
                select.dispatchEvent(event);
                const subscription_price = document.querySelector('[skio-subscription-price]').textContent.trim();
                buyButtonTextEl.innerHTML = `${buyButtonText} <span>|</span> ${subscription_price}`;
              });

              const labelText = document.createElement('div');
              labelText.className = 'skio-custom-radio-label';
              let radioLabel = option.text.trim();
              radioLabel = radioLabel.replace("Delivery", "");
              const subscriptionText = radioLabel.split(":");
              labelText.innerHTML = `<span>${subscriptionText[0].split('(')[0].trim()}</span>`;

              const subsTextLbs = subscriptionText[0].split('(');
              if(subsTextLbs[1]) {
                const subscriptionLbs = document.createElement('span');
                subscriptionLbs.textContent = `(${subsTextLbs[1]}`;
                labelText.append(subscriptionLbs);
              }
              if (subscriptionText[1]) {
                const subscriptionFrequency = document.createElement('span');
                subscriptionFrequency.textContent = subscriptionText[1];
                labelText.append(subscriptionFrequency);
              }

              wrapper.appendChild(radio);
              wrapper.appendChild(labelText);
              radioContainer.appendChild(wrapper);

              // Wrap SKio plan container
              if (document.querySelector('.skio-wrapper')) return;

              const selectedGroups = document.querySelectorAll('.skio-group-container');
              if (selectedGroups.length > 0) {
                // Create a wrapper div
                const skio_wrapper = document.createElement('div');
                skio_wrapper.className = 'skio-wrapper'; // Add your custom class if needed

                // Insert the wrapper before the first selected element
                const first = selectedGroups[0];
                first.parentNode.insertBefore(skio_wrapper, first);

                // Move all selected elements into the wrapper
                selectedGroups.forEach(el => skio_wrapper.appendChild(el));

                selectedGroups.forEach(el => {
                    const radioButton = el.querySelector('input[type="radio"]');
                    const productPrice = el.querySelector('.skio-price span');
                    let buttonText = `Add to cart <span>|</span> ${productPrice.textContent.trim()}`;
                    let isOtp = true;
                    if(!el.querySelector('.skio-group-input').hasAttribute('skio-one-time')) {
                      buttonText =  'Subscribe and save 40%';
                      isOtp = false;
                    }

                    radioButton.addEventListener('change', (event) => {
                      buyButtonTextEl.innerHTML = buttonText;
                      event.target.hasAttribute('skio-one-time') ? buyButton.classList.remove('sub') : buyButton.classList.add('sub');
                    })
                    if (radioButton.checked) {
                      isOtp ? buyButton.classList.remove('sub') : buyButton.classList.add('sub');
                      buyButtonTextEl.innerHTML = buttonText;
                    }
                });
              }
            });

            label.prepend(radioContainer);

            const plan_heading = document.createElement('button');
            plan_heading.setAttribute('class', 'subscription-plan-heading');

            plan_heading.innerHTML = `
              <span class="not-selected">Choose your pet size</span>
              <span class="arrow-icon">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="16" height="16" viewBox="0 0 256 256" xml:space="preserve">
                  <g style="stroke: none; stroke-width: 5; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
                    <path d="M 90 24.25 c 0 -0.896 -0.342 -1.792 -1.025 -2.475 c -1.366 -1.367 -3.583 -1.367 -4.949 0 L 45 60.8 L 5.975 21.775 c -1.367 -1.367 -3.583 -1.367 -4.95 0 c -1.366 1.367 -1.366 3.583 0 4.95 l 41.5 41.5 c 1.366 1.367 3.583 1.367 4.949 0 l 41.5 -41.5 C 89.658 26.042 90 25.146 90 24.25 z" style="stroke: none; stroke-width: 5; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: #5fd4ed; fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/>
                  </g>
                </svg>
              </span>
            `;

            radioContainer.insertAdjacentElement('beforebegin', plan_heading);

            // @Start dropdown
            plan_heading.addEventListener('click', () => {
              const isOpen = radioContainer.classList.contains('open');

              radioContainer.classList.toggle('open', !isOpen);
              plan_heading.querySelector('.arrow-icon').classList.toggle('open', !isOpen);

            });
            //@End

            observer.disconnect();
          }
        });
        const skioPlanPicker = document.querySelector('.skio-plan-picker');
        if (skioPlanPicker) {
          observer.observe(skioPlanPicker, {
            childList: true,
            subtree: true
          });
        }

        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}
